import type { ReactNode } from 'react';
import styles from './StepLayout.module.css';

export function StepLayout({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className={styles.layout}>
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.content}>{children}</div>
    </div>
  );
}
